import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wishlist-privacy-hint',
  imports: [],
  templateUrl: './wishlist-privacy-hint.component.html',
  styleUrl: './wishlist-privacy-hint.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistPrivacyHintComponent {}
